/**
 * created by tian ruo jun
 表单子项
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DatePicker, Input, Select} from "antd";
import moment from "moment";

const {TextArea} = Input;

export default class RmtText extends Component {
    static defaultProps = {
        type: "text",
        onChange: () => {
        },
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {value, disabled, field, onChange, formItemSizeConfig, id} = this.props;
        return <DatePicker
                id={id}
                showTime
                style={{ width: '100%' }}
                allowClear={false}
                value={value?moment(value):null}
                onChange={(value,b)=>{
                    let newDate = value && value.valueOf() ? value.valueOf() : null;
                    onChange(field, newDate)
                }}

            />
        // <Input
        //     id={id}
        //     size={formItemSizeConfig.inputSize || 'default'}
        //     placeholder={`请输入`}
        //     disabled={disabled}
        //     value={value}
        //     onChange={(e) => {
        //         let val = e.target.value || '';
        //         onChange(field, val)
        //     }}
        // />



    }

}